<ng-template [ngIf]="mode === 'general'">
    <nb-card>
        <nb-card-header>
            <span>{{ title }}</span>
            <button nbButton ghost size="tiny" class="float-right" (click)="dialog.close(false)">
                <i class="fa fa-times"></i>
            </button>
        </nb-card-header>
        <nb-card-body class="container">
            <div *ngFor="let message of messages" class="row mb-3">
                <div class="d-flex flex-column px-3">
                    <span *ngIf="message.header" class="mb-3">
                        <strong>{{ message.header }}</strong></span
                    >
                    <span>{{ message.message }}</span>
                </div>
            </div>
        </nb-card-body>
    </nb-card>
</ng-template>

<ng-template [ngIf]="mode === 'detail-plus'">
    <nb-card>
        <nb-card-header>
            <span>{{ title }}</span>
            <button nbButton ghost size="tiny" class="float-right" (click)="dialog.close(false)">
                <i class="fa fa-times"></i>
            </button>
        </nb-card-header>
        <nb-card-body class="container">
            <div *ngFor="let message of messages" class="row mb-3">
                <div class="d-flex flex-column px-3">
                    <span *ngIf="message.header" class="mb-3"
                        ><strong>{{ message.header }}</strong></span
                    >
                    <span>{{ message.message }}</span>
                </div>
            </div>
        </nb-card-body>
        <nb-card-footer>
            <div class="mr-5 row justify-content-end">
                <button nbButton appearance="ghost" (click)="dialog.close(false)">
                    <a [href]="helpLink" target="_blank">More Info</a>
                </button>
                <button nbButton status="primary" (click)="dialog.close(true)">Provide Feedback</button>
            </div>
        </nb-card-footer>
    </nb-card>
</ng-template>

<ng-template [ngIf]="mode === 'battery-order'">
    <nb-card>
        <nb-card-header>
            <span>{{ title }}</span>
            <button nbButton ghost size="tiny" class="float-right" (click)="dialog.close(false)">
                <i class="fa fa-times"></i>
            </button>
        </nb-card-header>
        <nb-card-body class="container">
            <div *ngFor="let message of messages" class="row mb-3">
                <div class="d-flex flex-column px-3">
                    <span *ngIf="message.header" class="mb-3">
                        <strong>{{ message.header }}</strong></span
                    >
                    <span>{{ message.message }}</span>
                </div>
            </div>
        </nb-card-body>
        <nb-card-footer>
            <div class="mr-5 row justify-content-end">
                <button nbButton appearance="ghost" (click)="dialog.close(false)">
                    <a [href]="helpLink" target="_blank">Purchase Batteries</a>
                </button>
            </div>
        </nb-card-footer>
    </nb-card>
</ng-template>
